import cn from 'classnames'
import Link from 'next/link'

export const Button = ({
  text,
  href = '/',
  type = 'link',
  color = 'primary',
  className,
  disabled = false,
}: {
  text: string
  href?: string
  type?: 'link' | 'button' | 'submit'
  color?: 'primary' | 'white'
  className?: string
  disabled?: boolean
}) => {
  const colorClass = disabled
    ? 'text-body-50 bg-body-10 border-body-25 cursor-not-allowed'
    : color === 'primary'
      ? 'text-white bg-primary border-primary hover:bg-white hover:text-primary'
      : 'bg-white text-primary border-primary hover:bg-primary hover:text-white'

  if (type === 'button' || type === 'submit') {
    return (
      <button
        type={type === 'submit' ? 'submit' : 'button'}
        disabled={disabled}
        className={cn(
          'inline-flex items-center gap-x-1 rounded-full py-fz-1 pl-fz-2 pr-fz-1.25 border transition-colors group',
          colorClass,
          className,
        )}
      >
        {text}
        <span className="material-symbols-outlined !text-[16px] transition-transform group-hover:translate-x-1">
          arrow_forward
        </span>
      </button>
    )
  } else {
    return (
      <Link
        href={href}
        className={cn(
          'inline-flex items-center gap-x-1 rounded-full py-fz-1 pl-fz-2 pr-fz-1.25 border transition-colors group',
          colorClass,
          className,
        )}
      >
        {text}
        <span className="material-symbols-outlined !text-[16px] transition-transform group-hover:translate-x-1">
          arrow_forward
        </span>
      </Link>
    )
  }
}
